import { render, staticRenderFns } from "./MemberInfo.vue?vue&type=template&id=20b0ace7&scoped=true&"
import script from "./MemberInfo.vue?vue&type=script&lang=js&"
export * from "./MemberInfo.vue?vue&type=script&lang=js&"
import style0 from "./MemberInfo.vue?vue&type=style&index=0&id=20b0ace7&lang=scss&scoped=true&"
import style1 from "./MemberInfo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b0ace7",
  null
  
)

export default component.exports